$ ->

  switcher = $ '[data-campaigns-list-filter-switcher]'

  show_active = () ->
    switcher.text(get_switcher_text('active'))

    $("[data-campaigns-group]").each () ->
      group = $ @
      group.find("[data-campaigns-list-filter-hidden-holder]").remove()
      group_id = +group.attr('data-campaigns-group')
      hidden_count = 0;
      group.find('[data-campaign-wrapper]').each () ->
        campaign = $ @
        campaign_id = +campaign.attr('data-campaign-id')
        campaign_enabled = +campaign.attr('data-campaign-enabled') == 1
        if not campaign_enabled
          hidden_count++
          campaign.addClass('hidden')

      if hidden_count
        colspan = group.find('tbody tr').eq(0).find('td').length || 1
        group.find('tbody').eq(0).append get_holder_html(group_id, hidden_count, colspan)

    INTENT.utils.Tooltip.init()

  show_all = () ->
    switcher.text(get_switcher_text('all'))
    $("[data-campaigns-list-filter-hidden-holder]").remove()
    $("[data-campaign-enabled]").removeClass('hidden')

  show_archive = (url) ->
    window.location.href = "#{url}"

  get_switcher_text = (action) ->
    return $("[data-campaigns-list-filter-action='#{action}']").text()

  get_holder_html = (group_id, hidden_count, colspan) ->
    """
    <tr data-campaigns-list-filter-hidden-holder>
      <td colspan="#{colspan}">
        <span class="badge">#{hidden_count}</span>
        &nbsp;
        <a href='#'
           data-campaigns-list-filter-hidden-show="#{group_id}"
           data-toggle='tooltip'
           data-placement='right'
           title="#{__('campaigns.list.filter.hidden_show')}"
        >#{__('campaigns.list.filter.hidden_count')}</a>
      </td>
    </tr>
    """


  $('[data-campaigns-list-filter-action]').on 'click', (e) ->
    e.preventDefault()
    self = $ @
    action = self.attr('data-campaigns-list-filter-action')
    switch action
      when 'active' then show_active()
      when 'all' then show_all()
      when 'archive' then show_archive(self.attr('data-campaigns-list-filter-url'))

  $(document).on 'click', '[data-campaigns-list-filter-hidden-show]', (e) ->
    e.preventDefault()
    self = $ @
    group_id = self.attr('data-campaigns-list-filter-hidden-show')
    group = $("[data-campaigns-group='#{group_id}']").eq(0)
    group.find("[data-campaign-enabled]").removeClass('hidden')
    INTENT.utils.Tooltip.destroy(self)
    self.closest("[data-campaigns-list-filter-hidden-holder]").remove()